module.exports = __webpack_public_path__ + "static/media/thankyou@2x.4f0c1258.jpg";